(function Quiz(){
  'use strict';

 

  var support = getSupport();
  var config = JSON.parse( document.querySelector('[data-quiz-config]').innerHTML );
  var filtersData = Object.freeze( objMap(validate, config.filters) );
  var productData = Object.freeze( config.products );
  var nodes;
  var historyQueue = [];

  compose(themeEditor, init)();

  function init(){
    nodes = {
      doc: [document],
      track: head(nodeList('.quiz-track')),
      panels: nodeList('.quiz-panel'),
      answers: nodeList('[data-answer-trigger]'),
      controls: nodeList('[data-quiz-index]'),
      showResults: nodeList('[data-show-results]'),
      showRemaining: nodeList('[data-show-remaining]'),
      takeQuiz: nodeList('[take-quiz]')
    }

    // Show/hide full results
    nodes.showRemaining.map(partial(addEvent,
      'click', compose(toggleRemainingResults)
      ));

    // Answer input select
    nodes.answers.map(partial(addEvent, 
      'change', compose(value, target)
    ));

    // Show results link click
    nodes.showResults.map(partial(addEvent, 
      'click', compose(UIshowResults, UIupdateResults, filterProducts, mapFilters, selectedFilters, selectedAnswers)
    ));

    // Next|Prev link click
    nodes.controls.map(partial(addEvent, 
      'click', compose(UIgoTo, UIdirection, target, preventDefault)
    ));

    // Question scroll/swipe
    nodes.doc.map(partial(addEvent, 
      'quiz-question-change', compose(UIloadImages, UIgetImages, UIupdateHash, UIhideResults, id, target)
    ));

    // Begin quiz
    nodes.takeQuiz.map(partial(addEvent,
      'click', compose(takeQuiz)
      ));

    // Scrollend listner
      support.IntersectionObserver ? 
      initIntersectionObserver(nodes.track, nodes.panels, scrollEndCallback) : initScrollObserver(nodes.track, scrollEndCallback);

  }

  var publicAPI = {
    goTo: UIgoTo,
    next: UInext,
    prev: UIprev,
    index: UIindex,
    nodes: nodes,
    products: productData,
    filters: filtersData,
  }

  var question;
  var answer;

// URL id fragment preservation
 function preserveCurrentQuestion() {
   var currentHash = window.location.hash;
   setTimeout(function() {
    window.location.hash = currentHash;
   }, 500)
 }
  window.onload = onloadFunc();
  
  // handles question repopulation and navigation on URL refresh
  function onloadFunc () {
    preserveCurrentQuestion();
    repopulate();
    if (window.location.hash === "#results") {

      setTimeout(function() {
        window.location.hash = "#question-6";
        console.log("hash");
      }, 550)
      
      // setTimeout(function() {
      //   document.getElementById("question-6").click();
      //   console.log('clicked');
      // }, 6000)
      
      // nodes.showResults.map(partial(addEvent, 
      //   'click', compose(UIshowResults, UIupdateResults, filterProducts, mapFilters, selectedFilters, selectedAnswers)
      // ));  
     

    }
  }


  var myPage = window.location.href;
  if (myPage.includes('&question')) {
    var startSection = document.querySelector('.get-started-section');
    var quizSection = document.querySelector('.quiz-section');
    startSection.setAttribute('hidden', true);
    quizSection.removeAttribute('hidden');
  }

  window.SectionsDesign = window.SectionsDesign || {};
  window.SectionsDesign.Quiz = publicAPI;
  return publicAPI;
  


  // ******************************

  /////// start set query variables
  function setQuestionValue(element) {
    question = `${element.id}-answer`;
  }

  function getSelectAnswer() {
    var options = document.getElementById(`${question}`);
    answer = `${options.value}`;
  }

  function getRadioAnswer() {
    var selected = document.querySelector('input[name="answer-for-question-5"]:checked').value;
    answer = `${selected}`;
  }

  function pushToURL() {
    var url = window.location.href;
    var myUrl = new URL(url);
    var search_params = myUrl.searchParams;
    search_params.set(question, answer);
    myUrl.search = search_params.toString();
    var new_url = myUrl.toString();
    history.pushState(null, 'custom URL', new_url);
  }

  function appendUrl(element) {
    if (element.id.includes('question') && element.id !== 'question-2') {
      setQuestionValue(element);
      if (element.id !== 'question-5') {
        getSelectAnswer();
      } else {
        getRadioAnswer();
      }
      pushToURL();
    }
  }
  /////// end set query variables

  ////// start repopulate answers

  //takes in question id, returns variable that matches question id, or false if there isn't one.
  function getQueryVariable(questionID) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] == questionID){return pair[1];}
    }
    return(false);
  }

  // returns array of question ids
  function getQuestions() {
    var questions = Array.from(document.querySelectorAll('.quiz-answers'));
    return questions.map(function(question) {
      return question.id;
    })
  }

  function repopulate() {
    var questions = getQuestions();
    for (var i = 0; i < questions.length; i++) {
     var questionElement = document.getElementById(`${questions[i]}`)
     var queryVariable = getQueryVariable(questions[i]);
     if (queryVariable) {
       questionElement.value = queryVariable;
       repopulateRadio(queryVariable);
     }
    }
  }

  function repopulateRadio(variable) {
    var option = document.getElementById(`${variable}`);
    option.checked = true;
  }

  ////// end repopulate answers

  // reveals the quiz
  function takeQuiz() {
    var questionsSection = document.querySelector('.questions-section');
    var startSection = document.querySelector('.get-started-section');
    startSection.setAttribute('hidden', true)
    questionsSection.removeAttribute('hidden');
  }

  function toggleRemainingResults() {
    var results = nodes.panels[7].childNodes[1].childNodes[1].childNodes;
    for (var i = 3; i < results.length; i++) {
      results[i].hidden ? results[i].removeAttribute('hidden') : results[i].setAttribute('hidden', true);
    }
  }

  // Returns array of selected answers from quiz questions.
  function selectedAnswers() {
    var answers = nodeList('[data-answer-trigger]:checked').map(value);
    return answers;
  }

  // Returns an array of the filters as objects.
  function selectedFilters(ids) {
    return flatten(props(ids, filtersData).filter(not(isEmpty)));
  }

  // Filter tags are passed in
  // Returns an array of functions that determine the proper filter function based on the quiz answers.
  function mapFilters(filters) {
    var fnMap = { price: priceFilter, tag: tagFilter, type: typeFilter, vendor: vendorFilter, option: optionFilter }
    return filters.map(function(filter) {
      return partial(fnMap[filter.type], filter.args);
    });
  }

  // Takes in entire collection and filter functions to be applied to each product.
  // Returns an array of products that pass all filters.
  function filterProducts(filterFns) {    
    var filteredProducts = productData.filter(function(product) {
      // allPass() returns a boolean based on whether product passes filter condition.
      return allPass(filterFns, product);
    });
    return filteredProducts;
  }

  // removes attribute on results that keeps them hidden.
  function UIshowResults() {
    var cloud = document.querySelector('.cloud');
    last(nodes.panels).removeAttribute('hidden');
    cloud.setAttribute('hidden', true);
  }

  function UIhideResults(panelId) {
    var resultsPanel = last(nodes.panels);
    var cloud = document.querySelector('.cloud');
    if (panelId !== id(resultsPanel)) {
      debounce(function(){
        resultsPanel.setAttribute('hidden', true);
        cloud.removeAttribute('hidden');
      }, 500)();
    }
    return panelId;
  }

 // Test for Fav tag in productArr 

  // Updates DOM with products that pass filters.
  function UIupdateResults(productArr) {
    var tags = ['1planet', '1zodiac', 'beadsize']
    var answers = selectedFilters(selectedAnswers());
    // console.log('answers', answers);
    cycle(productArr, tags, answers);
    // console.log('update answers', answers);
  }

  // runs filtering function until 10+ results are achieved
  function cycle(productArr, tags, answers) {
    if (productArr.length > 9) {
      // console.log('10+ productArr', productArr);
      displayResults(productArr);
    } else {
      // console.log('<10 productArr', productArr);
      var removedTag = tags.pop();
      if (removedTag) {
        answers = removeFilter(answers, removedTag);
        // console.log('updated answers', answers);
        var filterFns = mapFilters(answers);
        var updatedProductArr = filterProducts(filterFns)
        cycle(updatedProductArr, tags, answers);
      } else {
        displayNoResults(productData);
      }
    }
  }

  // removes filter from results
  function removeFilter(answers, tag) {
    return answers.filter(function(answer) {
      return hasTag(answer, tag) === false;
    })

  }

  // tests whether a filter's args contain a specified tag type.
  function hasTag(answer, tag) {
    for (var i = 0; i < answer.args.length; i++) {
      if (answer.args[i].includes(tag)) {
        return true;
      } else {
        return false;
      }
    }
  }



  // Adds product number to result html
  function injectProductNumber() {
    var results = Array.from(last(nodes.panels).querySelectorAll('.quiz-product'));
    var resultsNumber = Array.from(last(nodes.panels).querySelectorAll('.number-text'));
    var btnText = Array.from(last(nodes.panels).querySelectorAll('.btn-text'));
    for (var i = 0; i < results.length; i++) {
      btnText[i].innerText = 'Check Out Now';
      resultsNumber[i].innerText = i + 1;
      if (i > 2) {
        btnText[i].innerText = 'Check Out Now';
        hideExpandedResults(results[i]);
        // console.log('btnText', btnText);
      }
    }
  }

  // hides all but first 3 results on initial display
  function hideExpandedResults(result) {
    result.setAttribute('hidden', true);
  }

  // Gives new styles to results screen
  function resultsHeader() {
    var header = document.querySelector('.banner-wrapper');
    var headerText = document.querySelector('.banner--header');
    var content = document.querySelector('.content');
    var quizSection = document.querySelector('.quiz-section');
    header.setAttribute('result', true);
    content.setAttribute('result', true);
    headerText.setAttribute('result', true);
    headerText.innerText = "Sandy's Recommendations for you";
    quizSection.setAttribute('result', true);
  }

  // inserts filtered product html into results screen
  function displayResults(productArr) {
    var sortedArr = orderResults(productArr);
    var resultsFinal = sortedArr.slice(0, 10);
    // console.log('final', resultsFinal);
    var html = resultsFinal.reduce(function(acc, product){
      acc += product.html;
      return acc;
    }, '');
   resultsHeader();
    last(nodes.panels).querySelector('.quiz-main').innerHTML = html;
    injectProductNumber();
  }

  // displays "no results" html
  function displayNoResults(productData) {
    // console.log('productData', productData);
    var sandyArr = favFilter(productData);
    var resultsFinal = sandyArr.slice(0, 10);
    // console.log('sandyArr', sandyArr);
    var resultHTML = resultsFinal.reduce(function(acc, product){
      acc += product.html;
      return acc;
    }, '');
    var html = resultHTML;
   resultsHeader();
   var resultBtn = document.querySelector('.show-rest');
   resultBtn.setAttribute('hidden', true);
    last(nodes.panels).querySelector('.quiz-main').innerHTML = html;
    injectProductNumber();
  }

  // Returns array of 3 products tagged as Sandy favs
  function favFilter(productData) {
    var favTag = "special_sandy'sfavorite";
    var favArr = productData.filter(function(product) {
      return product.tags.includes(favTag);
    })
    return favArr.slice(0, 3);
  }

  // moves products with "Sandy's fav" tag to beginning of results
  function orderResults(productArr) {
    var favTag = "special_sandy'sfavorite";
    return productArr.reduce(function(acc, result) {
      if (result.tags.includes(favTag)) {
        return [result, ...acc];
      }
      return [...acc, result];
    }, [])
  }

  function UIindex() {
    var index = Math.round(nodes.track.scrollLeft / nodes.track.getBoundingClientRect().width);
    return clamp(index, 0, nodes.panels.length);
  }

  function UIdirection(element) {
    appendUrl(element);
    var result = Number(attr('data-quiz-index', element))
    return result;
  }

  // Back Button Handler
  function prevHandler(index) {
    var previous = event.target.getAttribute('previous');
    var resultsPrevious = event.target.getAttribute('results-prev'); 
    if (previous) {
      historyQueue.pop();
      if (resultsPrevious) {
        resetSection();
      }
    } else {
      historyQueue.push(index)
      var currentBackBtn = document.getElementById(`${index}`); 
      var backDestination;
      if (historyQueue.length < 2) {
        backDestination = 0; 
      } else {
        backDestination = historyQueue[historyQueue.length - 2];
      }
      currentBackBtn.setAttribute('data-quiz-index', backDestination);
    }
  }

  // Removes results styles from section
  function resetSection() {
    var quizSection = document.querySelector('.quiz-section');
    var header = document.querySelector('.banner-wrapper');
    var headerText = document.querySelector('.banner--header');
    var headerButton = document.querySelector('.banner--btn');
    var content = document.querySelector('.content');
    // quizSection.removeAttribute('result');
    // header.removeAttribute('result');
    // headerText.removeAttribute('result');
    // headerButton.removeAttribute('result');
    // content.removeAttribute('result');
  }

  function UIgoTo(index) {
    var track = nodes.track;
    var panel = head(nodes.panels);
    var x = track.getBoundingClientRect().width * index;
    prevHandler(index);

    (support.scrollBehavior || !support.customProperties) ? nativeScroll() : fallbackScroll();

    function nativeScroll() {
      track.scrollLeft = x;
    }

    function fallbackScroll() {
      track.style.setProperty('--scroll-x', (track.scrollLeft - x) + 'px');
      track.setAttribute('data-scroll-animation', true);
      panel.addEventListener('animationend', endAnimation);
    }

    function endAnimation() {
      panel.removeEventListener('animationend', endAnimation);
      track.removeAttribute('data-scroll-animation');
      nativeScroll();
    }
    
    return index;
  }

  function UInext() {
    var index = UIindex();
    var nextIndex = clamp((index + 1), 0, nodes.panels.length);
    return UIgoTo(nextIndex);
  }

  function UIprev() {
    var index = UIindex();
    var prevIndex = clamp((index - 1), 0, nodes.panels.length);
    return UIgoTo(prevIndex);
  }

  function UIupdateHash(panelId) {
    var newHash = '#' + panelId;
    var oldHash = window.location.hash;
    var shouldUpdate = not(equals)(newHash, oldHash);

    if (support.pushState && shouldUpdate) history.replaceState(null, null, newHash);
    return panelId;
  }

  function UIgetImages(panelId) {
    return nodeList('#' + panelId + ' [data-img]');
  }

  function UIloadImages(imagesArr) {
    var changeSrcset = partial(attrTransfer, 'data-lazy-srcset', 'srcset');
    var changeSrc = partial(attrTransfer, 'data-lazy-src', 'src');
    return imagesArr.map(changeSrcset).map(changeSrc);
  }

  /* Scroll */
  function scrollEndCallback(entries) {
    if (support.IntersectionObserver) {
      // IntersectionObserver callback
      var inView = entries.filter(function(entry){
        return (Math.round(entry.intersectionRatio) === 1);
      });

      if (inView.length > 0) {
        emitEvent('quiz-question-change', { target: head(inView).target });
      }
    } else {
      // ScrollObserver callback
      emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
    }
  }

  function initIntersectionObserver(root, rootNodes, callback) {
    var observer = new IntersectionObserver(callback, { root: root, threshold: 0.5 } );
    rootNodes.map(function(element) {
      observer.observe(element);
    })
  }

  function initScrollObserver(root, callback) {
    var initScroll = debounce(callback, 160);
    addEvent('scroll', initScroll, root);
    root.addEventListener('scroll', initScroll);

    // Init an initial change event to preload the panel images
    // emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
  }

  /* Validation */
  function validate(filters) {
    return filters.filter(function(filter) {
      var fnMap = { tag: arrValidation, type: arrValidation, vendor: arrValidation, price: priceValidation, option: optionValidation }
      var isValid = fnMap[filter.type];
      return not(isEmpty)(filter.args) && isValid(filter.args);
    })
  }

  function arrValidation(args) {
    return isArray(args);
  }
  
  function priceValidation(args) {
    return isNumber(head(args));
  }

  function optionValidation(args) {
    return isString(head(args)) && isArray(last(args));
  }
  
  /* Filters */
  function tagFilter(args, product) {
    return contains(args, product.tags);
  }
  
  function typeFilter(args, product) {
    return contains(args, product.type);
  }

  function vendorFilter(args, product) {
    return contains(args, product.vendor);
  }

  function priceFilter(args, product) {
    var operator = last(args);
    var n1 = product.price;
    var n2 = head(args);
    return numberComparison(operator, n1, n2);
  }

  function optionFilter(args, product) {
    var filterName = head(args);
    var filterValues = last(args);
    return product.options.some(function(option){
      return equals(option.name, filterName) && contains(option.values, filterValues);
    })
  }

  function numberComparison(operator, n1, n2) {
    if (operator === '=') return n1 === n2;
    else if (operator === '<') return n1 < n2;
    else if (operator === '>') return n1 > n2;
    else if (operator === '<=') return n1 <= n2;
    else if (operator === '>=') return n1 >= n2;
  }

  /* Event */
  function addEvent(type, fn, element) {
    element.addEventListener(type, fn);
  }

  function createEvent(eventType, data) {
    return new CustomEvent(eventType, { detail: data });
  }

  function emitEvent(eventType, data) {
    document.dispatchEvent(createEvent(eventType, data));
  }

  function preventDefault(evt) {
    evt.preventDefault();
    return evt;
  }

  function target(evt) {
    return (evt.detail && evt.detail.target) ? evt.detail.target : evt.target;
  }

  /* DOM */
  function id(element) {
    return element.id;
  }

  function attr(str, element) {
    return element.getAttribute(str);
  }

  function value(element) {
    return attr('value', element);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    var nodeList = root.querySelectorAll(str);
    return Array.prototype.slice.call(nodeList);
  }

  function attrTransfer(attr1, attr2, element) {
    nodeList('[' + attr2 + ']', element).map(function(el) {
      var newAttr = el.getAttribute(attr1);
      if (newAttr) {
        el.setAttribute(attr2, newAttr);
        el.removeAttribute(attr1);
      }
      return el;
    })
  }
  
  /* Object */
  function equals(a, b) {
    return a === b;
  }

  function keys(obj) {
    return Object.keys(obj);
  }

  function objMap(fn, obj) {
    return keys(obj).reduce(function(acc, key){
      acc[key] = fn(obj[key]);
      return acc;
    }, {});
  }

  function isNumber(arg) {
    return !isNaN(Number(arg));
  }

  function isString(arg) {
    return typeof arg === 'string' && arg.length !== 0;
  }

  function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
  }

  // Array
  function isArray(arg) {
    return Array.isArray(arg);
  }

  function isEmpty(arr) {
    return flatten(arr).every(function(item){
      return item.length < 0;
    });
  }

  // Function that does comparrison of filter and product tags
  function contains(arr1, arr2) {
    return arr1.some(function(value){
      return arr2.indexOf(value) !== -1;
    });
  }

  function flatten(arr) {
    return arr.reduce(function(acc, val) {
      return isArray(val) ? acc.concat(flatten(val)) : acc.concat(val);
    }, []);
  }

  function last(arr) {
    return arr[arr.length - 1];
  }

  function head(arr) {
    return arr[0];
  }

  function props(arr, obj) {
    return arr.reduce(function(acc, val){
      acc.push(obj[val]);
      return acc;
    }, []);
  }
  
  /* Fn */
  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  // taking in an array of filter functionss (fns) and a product object (arg)
  // fn determines whether the object contains the tag
  function allPass(fns, arg) {
    var predicates = fns.map(function(fn) {
      var hasTag = fn(arg);
      return hasTag
      //hasTag = [boolean]
    });
    var result = predicates.indexOf(false) === -1;
    return result
  }
// returns a boolean based on whether product has tags. 


  function debounce(fn, wait, immediate) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) fn.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) fn.apply(context, args);
    };
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function() {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function() {
      return funcs.slice(1).reduce(function(res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

  /* Support */
  function getSupport() {
    return {
      IntersectionObserver: 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype,
      CSSAnimation: 'animation' in document.body.style,
      pushState: window.history && window.history.pushState,
      customProperties: window.CSS && CSS.supports('color', 'var(--primary)'),
      scrollBehavior: 'scrollBehavior' in document.body.style
    }
  }

  /* Theme editor */
  function themeEditor() {
    document.addEventListener('shopify:block:select', function(evt) {
      publicAPI.goTo(config.blocks[evt.detail.blockId]);
    });

    document.addEventListener('shopify:section:load', function() {
      document.querySelector('.quiz-track').style.scrollBehavior = 'initial';
      init();
    });
  }

})();
